module.exports = __webpack_public_path__ + "static/media/servicio_empleo.ba8d4418.png";